export const EMBED_PROTOCOL_VERSION = '1.0.0'
export const EMBED_MESSAGE_SOURCE_HOST = 'ecmas-host'
export const EMBED_MESSAGE_SOURCE_IFRAME = 'ecmas-iframe'

export const HOST_TO_IFRAME_EVENT_TYPES = [
  'ECMAS_SDK_INIT',
  'ECMAS_SDK_LOGIN',
  'ECMAS_SDK_LOGOUT',
  'ECMAS_SDK_SET_EXT_DATA',
  'ECMAS_SDK_SHOW',
  'ECMAS_SDK_HIDE',
  'ECMAS_SDK_RESIZE',
  'ECMAS_SDK_NAVIGATE',
] as const

export const IFRAME_TO_HOST_EVENT_TYPES = [
  'ECMAS_IFRAME_READY',
  'ECMAS_IFRAME_RESIZE_REQUEST',
  'ECMAS_IFRAME_CALLBACK',
  'ECMAS_IFRAME_NAVIGATED',
] as const